import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { apiPublic } from '~/services/api';
import { HttpData } from '~/utils/network/HttpData';
import { SubspecialitiesModel } from '../subspecialities/SubspecialitiesModel';

export type SpecialitiesListAllResponse = {
  data: SpecialitiesListAllDetail[];
};

export type SpecialitiesListAllDetail = {
  id: number;
  name: string;
  description: string;
  slug: string;
  image: string;
  image_url: string;
  subspecialities: SubspecialitiesModel[];
};

export type SpecialitiesListAllPayload<T> = {
  config?: UseQueryOptions<T>;
};

export const useSpecialitiesListAll = (
  config?: SpecialitiesListAllPayload<HttpData<SpecialitiesListAllResponse>>
) => {
  return useQuery<
    HttpData<SpecialitiesListAllResponse>,
    Error,
    HttpData<SpecialitiesListAllResponse>
  >({
    queryKey: ['specialities', 'list-all'],
    queryFn: async () => {
      const response = await apiPublic({}).get<
        HttpData<SpecialitiesListAllResponse>
      >(`healthcare/specialities/v1/list-all`);
      return response.data;
    },
    ...config,
  });
};
